export default __webpack_public_path__ + "static/media/GC_13.2e49b7c6.png";